<px-m0230-text-video
    [videoright]='content.videoright'
    [videotype]='content.videotype'
    [headline]='content.headline'
    [text]='content.text'
    [youtubeid]='content.youtubeid'
    [mp4]='content.mp4'
></px-m0230-text-video>
